// import React, { useEffect, useState, forwardRef, useCallback, useMemo, useRef } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import {
//   Container,
//   Grid,
//   TextField,
//   Typography,
//   Divider,
//   Box,
//   Autocomplete,
//   Paper,
//   IconButton,
//   CircularProgress,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Slide,
//   CssBaseline,
//   Card,
//   CardContent,
//   Collapse,
//   Stack,
// } from "@mui/material";
// import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
// import { TransitionProps } from "@mui/material/transitions";
// import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import CloseIcon from "@mui/icons-material/Close";
// import FindInPageIcon from '@mui/icons-material/FindInPage';
// import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
// import NoSimIcon from '@mui/icons-material/NoSim';
// import InfoIcon from '@mui/icons-material/Info';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import ExpandLess from '@mui/icons-material/ExpandLess';
// import ExpandMore from '@mui/icons-material/ExpandMore';

// import HOST_URL from "../../../utils/Url";
// import ToastApp from "../../../ToastApp";
// import dayjs from "dayjs";
// import Flipbook from "./components/Flipbook";
// import { getSecureDevId, getSecureSubDeptId } from "../../../utils/storageHelpers";

// // Define interface for table row data for better type safety
// interface DocFile {
//   docMid: number;
//   pdfName: string;
//   keywords: string;
//   entryDate: string;
//   subFtype: string;
//   pdfPath?: string;
//   id: number; // Added for DataGrid
//   serialNo: number; // Added for serial numbers
// }

// // Define interface for the main document data
// interface DocumentData {
//   docMid: number;
//   fileNo: string;
//   fileDef: string;
//   synopsis: string;
//   fDate: string;
//   complt: string | null;
//   fileType: string | null;
//   fileType_Name: string;
//   divisionid: number;
//   department_Name: string;
//   fileTypId: number;
//   member_DocFiles: DocFile[];
// }

// // Define interface for autocomplete options
// interface AutoCompleteOption {
//   label: string;
//   value: number | string;
//   originalValue?: any;
// }

// // Define interface for department data
// interface Department {
//   id: number;
//   nodeID: number;
//   name: string;
//   titleID: number;
// }

// // Define interface for sub-department data
// interface SubDepartment {
//   subDeptID: number;
//   subDeptName: string;
//   deptID: number;
// }

// // Define interface for file type data
// interface FileType {
//   docID: number;
//   doc_Name: string;
//   doc_shortname: string;
//   session_year: string;
//   entry_Date: string;
//   inst_ID: number;
//   parentDocId: number | null;
//   parentLevel: number | null;
//   userId: number | null;
//   parentDoc_Name: string | null;
//   srn: number;
// }

// // Dialog Transition
// const Transition = forwardRef(function Transition(
//   props: TransitionProps & {
//     children: React.ReactElement<any, any>;
//   },
//   ref: React.Ref<unknown>
// ) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

// type Props = {};

// const DocViewer = (props: Props) => {
//   const navigate = useNavigate();

//   const [allDocuments, setAllDocuments] = useState<DocumentData[]>([]);
//   const [tableData, setTableData] = useState<DocFile[]>([]);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [selectedRowData, setSelectedRowData] = useState<DocFile | null>(null);
//   const [pdfShow, setPDFShow] = useState<string | null>(null);
//   const [isLoadingFiles, setIsLoadingFiles] = useState(false);
//   const [isLoadingPdf, setIsLoadingPdf] = useState(false);
//   const [filtersExpanded, setFiltersExpanded] = useState(true);

//   // Autocomplete options states
//   const [fileTypeOptions, setFileTypeOptions] = useState<AutoCompleteOption[]>([]);
//   const [synopsisOptions, setSynopsisOptions] = useState<AutoCompleteOption[]>([]);
//   const [departmentOptions, setDepartmentOptions] = useState<AutoCompleteOption[]>([]);
//   const [subDepartmentOptions, setSubDepartmentOptions] = useState<AutoCompleteOption[]>([]);
//   const [fileNoOptions, setFileNoOptions] = useState<AutoCompleteOption[]>([]);

//   // Selected filter values
//   const [selectedFileType, setSelectedFileType] = useState<AutoCompleteOption | null>(null);
//   const [selectedSynopsis, setSelectedSynopsis] = useState<AutoCompleteOption | null>(null);
//   const [selectedDepartment, setSelectedDepartment] = useState<AutoCompleteOption | null>(null);
//   const [selectedSubDepartment, setSelectedSubDepartment] = useState<AutoCompleteOption | null>(null);
//   const [selectedFileNo, setSelectedFileNo] = useState<AutoCompleteOption | null>(null);

//   // Loading states for APIs
//   const [loadingDepartments, setLoadingDepartments] = useState(false);
//   const [loadingSubDepartments, setLoadingSubDepartments] = useState(false);
//   const [loadingFileTypes, setLoadingFileTypes] = useState(false);

//   // DataGrid columns
//   const [columns, setColumns] = useState<GridColDef[]>([]);

//   // Refs to track initial setup and prevent re-renders
//   const initialSetupDone = useRef(false);
//   const initialDataFetched = useRef(false);

//   // Get secure IDs
//   const devId = getSecureDevId();
//   const subDeptID = getSecureSubDeptId();

//   // Convert to numbers safely
//   const devIdNum = devId !== -1 ? devId : -1;
//   const subDeptIDNum = subDeptID !== -1 ? subDeptID : -1;

//   // Check secure ID status
//   const isDevIdPresent = devIdNum !== -1;
//   const areBothSecureIdsPresent = devIdNum !== -1 && subDeptIDNum !== -1;
//   const isDevIdOnlyPresent = devIdNum !== -1 && subDeptIDNum === -1;

//   // Initialize DataGrid columns - only once on mount
//   useEffect(() => {
//     const initializeColumns = () => {
//       const columns: GridColDef[] = [
//         {
//           field: "serialNo",
//           headerName: "Sr No",
//           flex: 0.5,
//           headerClassName: "MuiDataGrid-colCell",
//           minWidth: 30,
//           renderCell: (params) => params.value
//         },
//         {
//           field: "pdfName",
//           headerName: "PDF Name",
//           flex: 2,
//           headerClassName: "MuiDataGrid-colCell",
//           minWidth: 200,
//           renderCell: (params) => (
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//               <PictureAsPdfIcon sx={{ mr: 1, color: 'error.main' }} />
//               {params.value}
//             </Box>
//           )
//         },
//         {
//           field: "keywords",
//           headerName: "Keywords",
//           flex: 2,
//           headerClassName: "MuiDataGrid-colCell",
//           minWidth: 150
//         },
//         {
//           field: "entryDate",
//           headerName: "Entry Date",
//           flex: 1,
//           headerClassName: "MuiDataGrid-colCell",
//           minWidth: 120,
//           renderCell: (params) =>
//             dayjs(params.value).isValid() ? dayjs(params.value).format("DD-MM-YYYY") : 'N/A'
//         },
//         {
//           field: "actions",
//           headerName: "Actions",
//           flex: 1,
//           headerClassName: "MuiDataGrid-colCell",
//           minWidth: 120,
//           renderCell: (params) => (
//             <Stack direction="row" spacing={1}>
//               <IconButton
//                 color="primary"
//                 aria-label="View PDF in 3D Viewer"
//                 onClick={() => handleOpenDialog(params.row)}
//                 title="View in 3D Viewer"
//                 size="small"
//               >
//                 <VisibilityIcon />
//               </IconButton>
//               <IconButton
//                 color="secondary"
//                 aria-label="Open PDF in new tab"
//                 onClick={() => handleInfoClick(params.row.pdfPath || '')}
//                 title="Open PDF in new tab"
//                 disabled={!params.row.pdfPath}
//                 size="small"
//               >
//                 <InfoIcon />
//               </IconButton>
//             </Stack>
//           )
//         }
//       ];
//       setColumns(columns);
//     };

//     initializeColumns();
//   }, []);

//   // Main initialization effect - runs once on mount
//   useEffect(() => {
//     if (initialSetupDone.current) return;

//     const initData = async () => {
//       setIsLoadingFiles(true);
//       try {
//         // Fetch all initial data in sequence
//         await fetchDepartments();
//         await fetchFileTypes();

//         initialSetupDone.current = true;
//       } catch (error) {
//         console.error("Error fetching initial data:", error);
//         toast.error("Failed to fetch initial data.");
//       } finally {
//         setIsLoadingFiles(false);
//       }
//     };

//     initData();
//   }, []);

//   // Fetch initial data after department and sub-department are properly set
//   useEffect(() => {
//     if (!initialSetupDone.current || initialDataFetched.current) return;

//     // Wait a moment to ensure all dropdowns are properly set
//     const timer = setTimeout(() => {
//       fetchDocumentsWithFilters();
//       initialDataFetched.current = true;
//     }, 300);

//     return () => clearTimeout(timer);
//   }, [initialSetupDone.current]);

//   // Fetch sub-departments when department changes (only if secure IDs are not present)
//   useEffect(() => {
//     if (!initialSetupDone.current) return;

//     // Only fetch sub-departments if department is selected AND no secure IDs are controlling it
//     if (selectedDepartment && !isDevIdPresent) {
//       fetchSubDepartments(Number(selectedDepartment.value));
//     } else if (!isDevIdPresent && initialSetupDone.current && !selectedDepartment) {
//       // If no department is selected and secure IDs are not present, clear sub-department options
//       setSubDepartmentOptions([]);
//       setSelectedSubDepartment(null);
//     }
//   }, [selectedDepartment?.value, isDevIdPresent, initialSetupDone.current]);

//   const fetchDocumentsWithFilters = useCallback(async () => {
//     setIsLoadingFiles(true);

//     // Prepare API payload with proper filtering based on secure IDs
//     const collectData = {
//       docMid: -1,
//       fileTypId: selectedFileType ? Number(selectedFileType.value) : -1,
//       divisionid: isDevIdPresent
//         ? devIdNum
//         : selectedDepartment
//           ? Number(selectedDepartment.value)
//           : -1,
//       subDeptID: (isDevIdPresent && selectedSubDepartment)
//         ? Number(selectedSubDepartment.value)
//         : (isDevIdPresent && areBothSecureIdsPresent)
//           ? subDeptIDNum
//           : selectedSubDepartment
//             ? Number(selectedSubDepartment.value)
//             : -1,
//       subsubjId: -1,
//       user_Id: -1,
//       fileNo: selectedFileNo ? String(selectedFileNo.value) : "",
//       synopsis: selectedSynopsis ? String(selectedSynopsis.value) : "",
//       complt: "",
//     };

//     try {
//       const response = await axios.post<{ data: DocumentData[] }>(
//         HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`,
//         collectData
//       );

//       const documents = response.data.data || [];
//       setAllDocuments(documents);

//       // Generate autocomplete options from filtered documents
//       generateAutoCompleteOptions(documents);

//       // Combine all member_DocFiles from all documents for the table
//       const allDocFiles: DocFile[] = [];
//       let serialNo = 1;

//       documents.forEach(doc => {
//         if (doc.member_DocFiles && doc.member_DocFiles.length > 0) {
//           const docFilesWithIds = doc.member_DocFiles.map(file => ({
//             ...file,
//             id: file.docMid + serialNo,
//             serialNo: serialNo++
//           }));
//           allDocFiles.push(...docFilesWithIds);
//         }
//       });

//       setTableData(allDocFiles);

//     } catch (error) {
//       console.error("Error fetching documents:", error);
//       toast.error("Failed to fetch documents.");
//     } finally {
//       setIsLoadingFiles(false);
//     }
//   }, [
//     selectedFileType,
//     selectedSynopsis,
//     selectedDepartment,
//     selectedSubDepartment,
//     selectedFileNo,
//     isDevIdPresent,
//     devIdNum,
//     areBothSecureIdsPresent,
//     subDeptIDNum,
//   ]);

//   const fetchDepartments = useCallback(async () => {
//     setLoadingDepartments(true);
//     const collectData = {
//       id: isDevIdPresent ? devIdNum : -1,
//       nodeID: -1,
//       titleID: -1,
//     };

//     try {
//       const response = await axios.post<{ data: Department[] }>(
//         HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`,
//         collectData
//       );

//       const departments = response.data.data || [];
//       const departmentOptions = departments.map((dept: Department) => ({
//         label: dept.name,
//         value: dept.id
//       }));

//       setDepartmentOptions(departmentOptions);

//       // If devId is present, set the department immediately
//       if (isDevIdPresent) {
//         const foundDept = departmentOptions.find(dept => dept.value === devIdNum);
//         if (foundDept) {
//           setSelectedDepartment(foundDept);
//           // Fetch sub-departments for this department
//           await fetchSubDepartments(devIdNum, true);
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching departments:", error);
//       toast.error("Failed to fetch departments.");
//     } finally {
//       setLoadingDepartments(false);
//     }
//   }, [isDevIdPresent, devIdNum]);

//   const fetchSubDepartments = useCallback(async (deptId: number, isInitialSetup: boolean = false) => {
//     if (deptId === -1) {
//       setSubDepartmentOptions([]);
//       return;
//     }

//     setLoadingSubDepartments(true);
//     try {
//       const response = await axios.post<{ data: SubDepartment[] }>(
//         HOST_URL.HOST_URL2 + `SubDepartmentMaster/GetSubDepartmentMaster`,
//         {
//           subDeptID: -1,
//           deptID: deptId
//         }
//       );

//       const subDepartments = response.data.data || [];
//       const subDepartmentOptions = subDepartments.map((subDept: SubDepartment) => ({
//         label: subDept.subDeptName,
//         value: subDept.subDeptID
//       }));

//       setSubDepartmentOptions(subDepartmentOptions);

//       // If this is initial setup and both secure IDs are present, find and set the sub-department
//       if (isInitialSetup && areBothSecureIdsPresent && subDeptIDNum !== -1) {
//         const foundSubDept = subDepartmentOptions.find(subDept => subDept.value === subDeptIDNum);
//         if (foundSubDept) {
//           setSelectedSubDepartment(foundSubDept);
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching sub-departments:", error);
//       toast.error("Failed to fetch sub-departments.");
//       setSubDepartmentOptions([]);
//     } finally {
//       setLoadingSubDepartments(false);
//     }
//   }, [areBothSecureIdsPresent, subDeptIDNum]);

//   const fetchFileTypes = useCallback(async () => {
//     setLoadingFileTypes(true);
//     const collectData = {
//       docID: -1,
//       parentDocId: -1,
//       userId: ""
//     };

//     try {
//       const response = await axios.post<{ data: FileType[] }>(
//         HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`,
//         collectData
//       );

//       const fileTypes = response.data.data || [];
//       const fileTypeOptions = fileTypes.map((fileType: FileType) => ({
//         label: fileType.doc_Name,
//         value: fileType.docID
//       }));

//       setFileTypeOptions(fileTypeOptions);
//     } catch (error) {
//       console.error("Error fetching file types:", error);
//       toast.error("Failed to fetch file types.");
//     } finally {
//       setLoadingFileTypes(false);
//     }
//   }, []);

//   const generateAutoCompleteOptions = useCallback((documents: DocumentData[]) => {
//     // Synopsis Options
//     const synopses = Array.from(new Set(documents
//       .map(doc => doc.synopsis)
//       .filter(Boolean)))
//       .map(synopsis => ({
//         label: synopsis as string,
//         value: synopsis as string
//       }));
//     setSynopsisOptions(synopses);

//     // File No Options
//     const fileNos = Array.from(new Set(documents
//       .map(doc => doc.fileNo)
//       .filter(Boolean)))
//       .map(fileNo => ({
//         label: fileNo as string,
//         value: fileNo as string
//       }));
//     setFileNoOptions(fileNos);
//   }, []);

//   // Fetch documents when any filter changes
//   useEffect(() => {
//     if (!initialDataFetched.current) return;

//     const timer = setTimeout(() => {
//       fetchDocumentsWithFilters();
//     }, 500);

//     return () => clearTimeout(timer);
//   }, [
//     selectedFileType?.value,
//     selectedSynopsis?.value,
//     selectedSubDepartment?.value,
//     selectedFileNo?.value,
//     initialDataFetched.current,
//     selectedDepartment?.value
//   ]);

//   // Handle individual filter changes
//   const handleFileTypeChange = useCallback((event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
//     setSelectedFileType(newValue);
//   }, []);

//   const handleSynopsisChange = useCallback((event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
//     setSelectedSynopsis(newValue);
//   }, []);

//   const handleDepartmentChange = useCallback((event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
//     // Only allow department change if devId is not present
//     if (!isDevIdPresent) {
//       setSelectedDepartment(newValue);
//     }
//   }, [isDevIdPresent]);

//   const handleSubDepartmentChange = useCallback((event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
//     // Only allow sub-department change if both secure IDs are not present
//     // If only devId is present, user can change sub-department
//     if (!areBothSecureIdsPresent) {
//       setSelectedSubDepartment(newValue);
//     }
//   }, [areBothSecureIdsPresent]);

//   const handleFileNoChange = useCallback((event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
//     setSelectedFileNo(newValue);
//   }, []);

//   // Reset all filters
//   const handleResetFilters = useCallback(() => {
//     setSelectedFileType(null);
//     setSelectedSynopsis(null);

//     // Only reset department and sub-department if secure IDs are not present
//     if (!isDevIdPresent) {
//       setSelectedDepartment(null);
//       setSelectedSubDepartment(null);
//       setSubDepartmentOptions([]);
//     } else if (isDevIdOnlyPresent) {
//       // If only devId is present, keep department selected but reset sub-department
//       setSelectedSubDepartment(null);
//     }

//     setSelectedFileNo(null);
//     setPDFShow(null);
//   }, [isDevIdPresent, isDevIdOnlyPresent]);

//   // Fetch Specific PDF Data by ID
//   const fetchPdfData = useCallback(async (docMid: number) => {
//     setIsLoadingPdf(true);
//     setPDFShow(null);
//     const collectData = {
//       docMid: docMid,
//       fileTypId: 0,
//       divisionid: 0,
//       subDeptID: 0,
//       subsubjId: 0,
//       user_Id: 0,
//       fileNo: "",
//       synopsis: "",
//       complt: ""
//     };
//     try {
//       const response = await axios.post<{ data: any[] }>(
//         HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`,
//         collectData
//       );

//       if (
//         response?.data?.data &&
//         response.data.data.length > 0 &&
//         response.data.data[0]?.member_DocFiles &&
//         response.data.data[0].member_DocFiles.length > 0 &&
//         response.data.data[0].member_DocFiles[0]?.pdfPath
//       ) {
//         setPDFShow(response.data.data[0].member_DocFiles[0].pdfPath);
//       } else {
//         console.warn("PDF data not found in response for docMid:", docMid);
//         toast.info("PDF data not found for this document.");
//         setPDFShow(null);
//       }
//     } catch (error) {
//       console.error("Error fetching PDF data:", error);
//       toast.error("Failed to fetch PDF data.");
//       setPDFShow(null);
//     } finally {
//       setIsLoadingPdf(false);
//     }
//   }, []);

//   // Open Dialog Handler (for Eye icon)
//   const handleOpenDialog = useCallback((rowData: DocFile) => {
//     setSelectedRowData(rowData);
//     setOpenDialog(true);
//     fetchPdfData(rowData.docMid);
//   }, [fetchPdfData]);

//   // Handle Info icon click - Open PDF URL in new tab
//   const handleInfoClick = useCallback((pdfPath: string) => {
//     if (pdfPath) {
//       window.open(pdfPath, '_blank', 'noopener,noreferrer');
//     } else {
//       toast.error("No PDF URL available");
//     }
//   }, []);

//   // Close Dialog Handler
//   const handleCloseDialog = useCallback(() => {
//     setOpenDialog(false);
//     setTimeout(() => {
//       setSelectedRowData(null);
//       setPDFShow(null);
//       setIsLoadingPdf(false);
//     }, 300);
//   }, []);

//   const toggleFilters = useCallback(() => {
//     setFiltersExpanded(!filtersExpanded);
//   }, [filtersExpanded]);

//   // Function to get appropriate placeholder text for sub-department
//   const getSubDepartmentPlaceholder = useCallback(() => {
//     if (areBothSecureIdsPresent) {
//       return "Pre-selected from secure ID";
//     } else if (isDevIdOnlyPresent) {
//       return "Select sub-department (optional)";
//     } else if (selectedDepartment) {
//       return "Select sub-department";
//     } else {
//       return "Select department first";
//     }
//   }, [areBothSecureIdsPresent, isDevIdOnlyPresent, selectedDepartment]);

//   return (
//     <>
//       <CssBaseline />
//       <ToastApp />
//       <Container maxWidth="lg" sx={{ mt: 1, mb: 1 }}>
//         <Paper elevation={3} sx={{ p: 1, borderRadius: 2 }}>
//           {/* Header Section */}
//           <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//             <Typography variant="h5" component="h2" sx={{ ml: 1, fontWeight: 'medium' }}>
//               Document Viewer
//             </Typography>
//           </Box>
//           {/* Enhanced Compact Filters Section */}
//           <Card
//             variant="outlined"
//             sx={{
//               mb: 2,
//               '& .MuiCardContent-root': {
//                 padding: 1,
//                 '&:last-child': {
//                   paddingBottom: 1
//                 }
//               }
//             }}
//           >
//             <CardContent>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'space-between',
//                   cursor: 'pointer',
//                   p: 0.5
//                 }}
//                 onClick={toggleFilters}
//               >
//                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                   <FilterListIcon sx={{ mr: 1, fontSize: 18 }} />
//                   <Typography variant="h6" sx={{ fontSize: 18 }}>
//                     Filters
//                   </Typography>
//                 </Box>
//                 {/* Reset Button */}
//                 <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center' }}>
//                   <Button
//                     variant="outlined"
//                     onClick={handleResetFilters}
//                     size="small"
//                     sx={{ minWidth: 'auto', px: 1 }}
//                   >
//                     Reset
//                   </Button>
//                 </Box>
//                 <IconButton size="small">
//                   {filtersExpanded ? <ExpandLess /> : <ExpandMore />}
//                 </IconButton>
//               </Box>

//               <Collapse in={filtersExpanded}>
//                 <Grid container spacing={1}>
//                   {/* Department Autocomplete */}
//                   <Grid item xs={12} sm={6} md={3}>
//                     <Autocomplete
//                       options={departmentOptions}
//                       value={selectedDepartment}
//                       onChange={handleDepartmentChange}
//                       getOptionLabel={(option) => option.label}
//                       isOptionEqualToValue={(option, value) => option.value === value.value}
//                       loading={loadingDepartments}
//                       disabled={isDevIdPresent}
//                       size="small"
//                       renderInput={(params) => (
//                         <TextField
//                           {...params}
//                           label="Department"
//                           variant="outlined"
//                           size="small"
//                           fullWidth
//                           placeholder={isDevIdPresent ? "Pre-selected from secure ID" : "Select department"}
//                           InputProps={{
//                             ...params.InputProps,
//                             endAdornment: (
//                               <>
//                                 {loadingDepartments ? <CircularProgress color="inherit" size={18} /> : null}
//                                 {params.InputProps.endAdornment}
//                               </>
//                             ),
//                           }}
//                         />
//                       )}
//                     />
//                   </Grid>

//                   {/* Sub-Department Autocomplete */}
//                   <Grid item xs={12} sm={6} md={3}>
//                     <Autocomplete
//                       options={subDepartmentOptions}
//                       value={selectedSubDepartment}
//                       onChange={handleSubDepartmentChange}
//                       getOptionLabel={(option) => option.label}
//                       isOptionEqualToValue={(option, value) => option.value === value.value}
//                       loading={loadingSubDepartments}
//                       disabled={!selectedDepartment || areBothSecureIdsPresent || loadingSubDepartments}
//                       size="small"
//                       renderInput={(params) => (
//                         <TextField
//                           {...params}
//                           label="Sub-Department"
//                           variant="outlined"
//                           size="small"
//                           fullWidth
//                           placeholder={getSubDepartmentPlaceholder()}
//                           InputProps={{
//                             ...params.InputProps,
//                             endAdornment: (
//                               <>
//                                 {loadingSubDepartments ? <CircularProgress color="inherit" size={18} /> : null}
//                                 {params.InputProps.endAdornment}
//                               </>
//                             ),
//                           }}
//                         />
//                       )}
//                     />
//                   </Grid>

//                   {/* Synopsis Autocomplete */}
//                   <Grid item xs={12} sm={6} md={3}>
//                     <Autocomplete
//                       options={synopsisOptions}
//                       value={selectedSynopsis}
//                       onChange={handleSynopsisChange}
//                       getOptionLabel={(option) => option.label}
//                       isOptionEqualToValue={(option, value) => option.value === value.value}
//                       size="small"
//                       renderInput={(params) => (
//                         <TextField
//                           {...params}
//                           label="File name"
//                           variant="outlined"
//                           size="small"
//                           fullWidth
//                           placeholder="Select file name"
//                         />
//                       )}
//                     />
//                   </Grid>

//                   {/* File Type Autocomplete */}
//                   <Grid item xs={12} sm={6} md={3}>
//                     <Autocomplete
//                       options={fileTypeOptions}
//                       value={selectedFileType}
//                       onChange={handleFileTypeChange}
//                       getOptionLabel={(option) => option.label}
//                       isOptionEqualToValue={(option, value) => option.value === value.value}
//                       loading={loadingFileTypes}
//                       size="small"
//                       renderInput={(params) => (
//                         <TextField
//                           {...params}
//                           label="File Type"
//                           variant="outlined"
//                           size="small"
//                           fullWidth
//                           placeholder="Select file type"
//                           InputProps={{
//                             ...params.InputProps,
//                             endAdornment: (
//                               <>
//                                 {loadingFileTypes ? <CircularProgress color="inherit" size={18} /> : null}
//                                 {params.InputProps.endAdornment}
//                               </>
//                             ),
//                           }}
//                         />
//                       )}
//                     />
//                   </Grid>

//                   {/* File No Autocomplete */}
//                   <Grid item xs={12} sm={6} md={3}>
//                     <Autocomplete
//                       options={fileNoOptions}
//                       value={selectedFileNo}
//                       onChange={handleFileNoChange}
//                       getOptionLabel={(option) => option.label}
//                       isOptionEqualToValue={(option, value) => option.value === value.value}
//                       size="small"
//                       renderInput={(params) => (
//                         <TextField
//                           {...params}
//                           label="File No"
//                           variant="outlined"
//                           size="small"
//                           fullWidth
//                           placeholder="Select file number"
//                         />
//                       )}
//                     />
//                   </Grid>
//                 </Grid>
//               </Collapse>
//             </CardContent>
//           </Card>

//           {/* DataGrid Section */}
//           <Grid container spacing={2}>
//             <Grid item xs={12}>
//               <Paper
//                 variant="outlined"
//                 sx={{
//                   width: '100%',
//                   overflow: 'hidden',
//                   "& .MuiDataGrid-colCell": {
//                     backgroundColor: `var(--grid-headerBackground)`,
//                     color: `var(--grid-headerColor)`,
//                     fontSize: 14,
//                     fontWeight: 600
//                   },
//                 }}
//               >
//                 {tableData.length > 0 ? (
//                   <Box sx={{ width: '100%', backgroundColor: `var(--grid-background)` }}>
//                     <DataGrid
//                       rows={tableData}
//                       columns={columns}
//                       autoHeight
//                       slots={{
//                         toolbar: GridToolbar,
//                       }}
//                       rowSpacingType="border"
//                       pagination={true}
//                       pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
//                         value: size,
//                         label: `${size}`,
//                       }))}
//                       initialState={{
//                         pagination: { paginationModel: { pageSize: 5 } },
//                       }}
//                       slotProps={{
//                         toolbar: {
//                           showQuickFilter: true,
//                         },
//                       }}
//                       loading={isLoadingFiles}
//                       sx={{
//                         '& .MuiDataGrid-cell': {
//                           borderBottom: '1px solid #e0e0e0',
//                           fontSize: '0.875rem',
//                         },
//                         '& .MuiDataGrid-row:hover': {
//                           backgroundColor: 'rgba(0, 0, 0, 0.04)',
//                         },
//                         '& .MuiDataGrid-toolbarContainer': {
//                           padding: 1,
//                         },
//                       }}
//                     />
//                   </Box>
//                 ) : (
//                   <Box sx={{
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     p: 2,
//                     color: 'text.secondary',
//                     minHeight: 120
//                   }}>
//                     <FindInPageIcon sx={{ mr: 1, fontSize: 30 }} />
//                     <Typography variant="body1">
//                       {isLoadingFiles ? "Loading documents..." : "No documents found for the selected filters"}
//                     </Typography>
//                   </Box>
//                 )}
//               </Paper>
//             </Grid>
//           </Grid>
//         </Paper>

//         {/* PDF Viewer Dialog (3D Flipbook) */}
//         <Dialog
//           fullScreen
//           open={openDialog}
//           onClose={handleCloseDialog}
//           TransitionComponent={Transition}
//           aria-labelledby="pdf-viewer-dialog-title"
//         >
//           <DialogTitle sx={{ m: 0, p: 2, backgroundColor: 'primary.main', color: 'white' }} id="pdf-viewer-dialog-title">
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//               <Typography variant="h6" component="div">
//                 PDF Viewer - {selectedRowData?.pdfName || 'Document'}
//               </Typography>
//               <IconButton
//                 aria-label="close"
//                 onClick={handleCloseDialog}
//                 sx={{ color: 'white' }}
//               >
//                 <CloseIcon />
//               </IconButton>
//             </Box>
//           </DialogTitle>
//           <DialogContent dividers sx={{
//             p: 0,
//             backgroundColor: '#f7f7f7',
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             overflow: 'hidden'
//           }}>
//             {isLoadingPdf ? (
//               <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
//                 <CircularProgress size={60} />
//                 <Typography sx={{ mt: 2 }}>Loading PDF...</Typography>
//               </Box>
//             ) : pdfShow ? (
//               <Box sx={{ width: '100%', height: '100%', overflow: 'auto' }}>
//                 <Flipbook filePath={pdfShow} />
//               </Box>
//             ) : (
//               <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', textAlign: 'center', p: 3 }}>
//                 <NoSimIcon sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
//                 <Typography variant="h6" color="text.secondary">
//                   No Pdf Preview Available
//                 </Typography>
//               </Box>
//             )}
//           </DialogContent>
//         </Dialog>
//       </Container>
//     </>
//   );
// };

// export default DocViewer;





import React, { useEffect, useState, forwardRef, useCallback, useMemo, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Container,
  Grid,
  TextField,
  Typography,
  Divider,
  Box,
  Autocomplete,
  Paper,
  IconButton,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Slide,
  CssBaseline,
  Card,
  CardContent,
  Collapse,
  Stack,
} from "@mui/material";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import { TransitionProps } from "@mui/material/transitions";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from "@mui/icons-material/Close";
import FindInPageIcon from '@mui/icons-material/FindInPage';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import NoSimIcon from '@mui/icons-material/NoSim';
import InfoIcon from '@mui/icons-material/Info';
import FilterListIcon from '@mui/icons-material/FilterList';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import HOST_URL from "../../../utils/Url";
import ToastApp from "../../../ToastApp";
import dayjs from "dayjs";
import Flipbook from "./components/Flipbook";
import { getSecureDevId, getSecureSubDeptId } from "../../../utils/storageHelpers";

// Define interface for table row data for better type safety
interface DocFile {
  docMid: number;
  pdfName: string;
  keywords: string;
  entryDate: string;
  subFtype: string;
  pdfPath?: string;
  id: number; // Added for DataGrid
  serialNo: number; // Added for serial numbers
}

// Define interface for the main document data
interface DocumentData {
  docMid: number;
  fileNo: string;
  fileDef: string;
  synopsis: string;
  fDate: string;
  complt: string | null;
  fileType: string | null;
  fileType_Name: string;
  divisionid: number;
  department_Name: string;
  fileTypId: number;
  member_DocFiles: DocFile[];
}

// Define interface for autocomplete options
interface AutoCompleteOption {
  label: string;
  value: number | string;
  originalValue?: any;
}

// Define interface for department data
interface Department {
  id: number;
  nodeID: number;
  name: string;
  titleID: number;
}

// Define interface for sub-department data
interface SubDepartment {
  subDeptID: number;
  subDeptName: string;
  deptID: number;
}

// Define interface for file type data
interface FileType {
  docID: number;
  doc_Name: string;
  doc_shortname: string;
  session_year: string;
  entry_Date: string;
  inst_ID: number;
  parentDocId: number | null;
  parentLevel: number | null;
  userId: number | null;
  parentDoc_Name: string | null;
  srn: number;
}

// Dialog Transition
const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type Props = {};

const DocViewer = (props: Props) => {
  const navigate = useNavigate();

  const [allDocuments, setAllDocuments] = useState<DocumentData[]>([]);
  const [tableData, setTableData] = useState<DocFile[]>([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<DocFile | null>(null);
  const [pdfShow, setPDFShow] = useState<string | null>(null);
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);
  const [isLoadingPdf, setIsLoadingPdf] = useState(false);
  const [filtersExpanded, setFiltersExpanded] = useState(true);

  // Autocomplete options states
  const [fileTypeOptions, setFileTypeOptions] = useState<AutoCompleteOption[]>([]);
  const [synopsisOptions, setSynopsisOptions] = useState<AutoCompleteOption[]>([]);
  const [departmentOptions, setDepartmentOptions] = useState<AutoCompleteOption[]>([]);
  const [subDepartmentOptions, setSubDepartmentOptions] = useState<AutoCompleteOption[]>([]);
  const [fileNoOptions, setFileNoOptions] = useState<AutoCompleteOption[]>([]);

  // Selected filter values
  const [selectedFileType, setSelectedFileType] = useState<AutoCompleteOption | null>(null);
  const [selectedSynopsis, setSelectedSynopsis] = useState<AutoCompleteOption | null>(null);
  const [selectedDepartment, setSelectedDepartment] = useState<AutoCompleteOption | null>(null);
  const [selectedSubDepartment, setSelectedSubDepartment] = useState<AutoCompleteOption | null>(null);
  const [selectedFileNo, setSelectedFileNo] = useState<AutoCompleteOption | null>(null);

  // Loading states for APIs
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [loadingSubDepartments, setLoadingSubDepartments] = useState(false);
  const [loadingFileTypes, setLoadingFileTypes] = useState(false);

  // DataGrid columns
  const [columns, setColumns] = useState<GridColDef[]>([]);

  // Refs to track initial setup and prevent re-renders
  const initialSetupDone = useRef(false);
  const initialDataFetched = useRef(false);

  // Get secure IDs
  const devId = getSecureDevId();
  const subDeptID = getSecureSubDeptId();

  // Convert to numbers safely
  const devIdNum = devId !== -1 ? devId : -1;
  const subDeptIDNum = subDeptID !== -1 ? subDeptID : -1;

  // Check secure ID status
  const isDevIdPresent = devIdNum !== -1;
  const areBothSecureIdsPresent = devIdNum !== -1 && subDeptIDNum !== -1;
  const isDevIdOnlyPresent = devIdNum !== -1 && subDeptIDNum === -1;

  // Initialize DataGrid columns - only once on mount
  useEffect(() => {
    const initializeColumns = () => {
      const columns: GridColDef[] = [
        {
          field: "serialNo",
          headerName: "Sr No",
          flex: 0.5,
          headerClassName: "MuiDataGrid-colCell",
          minWidth: 30,
          renderCell: (params) => params.value
        },
        {
          field: "pdfName",
          headerName: "PDF Name",
          flex: 2,
          headerClassName: "MuiDataGrid-colCell",
          minWidth: 200,
          renderCell: (params) => (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <PictureAsPdfIcon sx={{ mr: 1, color: 'error.main' }} />
              {params.value}
            </Box>
          )
        },
        {
          field: "keywords",
          headerName: "Keywords",
          flex: 2,
          headerClassName: "MuiDataGrid-colCell",
          minWidth: 150
        },
        {
          field: "entryDate",
          headerName: "Entry Date",
          flex: 1,
          headerClassName: "MuiDataGrid-colCell",
          minWidth: 120,
          renderCell: (params) =>
            dayjs(params.value).isValid() ? dayjs(params.value).format("DD-MM-YYYY") : 'N/A'
        },
        {
          field: "actions",
          headerName: "Actions",
          flex: 1,
          headerClassName: "MuiDataGrid-colCell",
          minWidth: 120,
          renderCell: (params) => (
            <Stack direction="row" spacing={1}>
              <IconButton
                color="primary"
                aria-label="View PDF in 3D Viewer"
                onClick={() => handleOpenDialog(params.row)}
                title="View in 3D Viewer"
                size="small"
              >
                <VisibilityIcon />
              </IconButton>
              <IconButton
                color="secondary"
                aria-label="Open PDF in new tab"
                onClick={() => handleInfoClick(params.row.pdfPath || '')}
                title="Open PDF in new tab"
                disabled={!params.row.pdfPath}
                size="small"
              >
                <InfoIcon />
              </IconButton>
            </Stack>
          )
        }
      ];
      setColumns(columns);
    };

    initializeColumns();
  }, []);

  // Main initialization effect - runs once on mount
  // useEffect(() => {
  //   if (initialSetupDone.current) return;

  //   const initData = async () => {
  //     setIsLoadingFiles(true);
  //     try {
  //       // Fetch all initial data in sequence
  //       await fetchDepartments();
  //       await fetchFileTypes();

  //       initialSetupDone.current = true;
  //     } catch (error) {
  //       console.error("Error fetching initial data:", error);
  //       toast.error("Failed to fetch initial data.");
  //     } finally {
  //       setIsLoadingFiles(false);
  //     }
  //   };

  //   initData();
  // }, []);
  // Main initialization effect - runs once on mount
  useEffect(() => {
    if (initialSetupDone.current) return;

    const initData = async () => {
      setIsLoadingFiles(true);
      try {
        // Fetch all initial data in sequence
        await fetchDepartments();

        // 🔴 यहाँ change - department ID ke saath file types fetch करें
        let initialDeptId = -1;
        if (isDevIdPresent) {
          initialDeptId = devIdNum;
        }
        await fetchFileTypes(initialDeptId);

        initialSetupDone.current = true;
      } catch (error) {
        console.error("Error fetching initial data:", error);
        toast.error("Failed to fetch initial data.");
      } finally {
        setIsLoadingFiles(false);
      }
    };

    initData();
  }, []);


  // 🔴 NEW useEffect - Department change hone par file types fetch karna
useEffect(() => {
  if (!initialSetupDone.current) return;
  
  // Department ID determine karein
  let departmentId = -1;
  
  if (isDevIdPresent) {
    // Agar secure dev ID hai to uska use karein
    departmentId = devIdNum;
  } else if (selectedDepartment) {
    // Warna selected department ka ID lein
    departmentId = Number(selectedDepartment.value);
  }
  
  // File types fetch karein
  fetchFileTypes(departmentId);
  
}, [selectedDepartment?.value, isDevIdPresent, devIdNum, initialSetupDone.current]);

  // Fetch initial data after department and sub-department are properly set
  useEffect(() => {
    if (!initialSetupDone.current || initialDataFetched.current) return;

    // Wait a moment to ensure all dropdowns are properly set
    const timer = setTimeout(() => {
      fetchDocumentsWithFilters();
      initialDataFetched.current = true;
    }, 300);

    return () => clearTimeout(timer);
  }, [initialSetupDone.current]);

  // Fetch sub-departments when department changes (only if secure IDs are not present)
  useEffect(() => {
    if (!initialSetupDone.current) return;

    // Only fetch sub-departments if department is selected AND no secure IDs are controlling it
    if (selectedDepartment && !isDevIdPresent) {
      fetchSubDepartments(Number(selectedDepartment.value));
    } else if (!isDevIdPresent && initialSetupDone.current && !selectedDepartment) {
      // If no department is selected and secure IDs are not present, clear sub-department options
      setSubDepartmentOptions([]);
      setSelectedSubDepartment(null);
    }
  }, [selectedDepartment?.value, isDevIdPresent, initialSetupDone.current]);

  const fetchDocumentsWithFilters = useCallback(async () => {
    setIsLoadingFiles(true);

    // Prepare API payload with proper filtering based on secure IDs
    const collectData = {
      docMid: -1,
      fileTypId: selectedFileType ? Number(selectedFileType.value) : -1,
      divisionid: isDevIdPresent
        ? devIdNum
        : selectedDepartment
          ? Number(selectedDepartment.value)
          : -1,
      subDeptID: (isDevIdPresent && selectedSubDepartment)
        ? Number(selectedSubDepartment.value)
        : (isDevIdPresent && areBothSecureIdsPresent)
          ? subDeptIDNum
          : selectedSubDepartment
            ? Number(selectedSubDepartment.value)
            : -1,
      subsubjId: -1,
      user_Id: -1,
      fileNo: selectedFileNo ? String(selectedFileNo.value) : "",
      synopsis: selectedSynopsis ? String(selectedSynopsis.value) : "",
      complt: "",
    };

    try {
      const response = await axios.post<{ data: DocumentData[] }>(
        HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`,
        collectData
      );

      const documents = response.data.data || [];
      setAllDocuments(documents);

      // Generate autocomplete options from filtered documents
      generateAutoCompleteOptions(documents);

      // Combine all member_DocFiles from all documents for the table
      const allDocFiles: DocFile[] = [];
      let serialNo = 1;

      documents.forEach(doc => {
        if (doc.member_DocFiles && doc.member_DocFiles.length > 0) {
          const docFilesWithIds = doc.member_DocFiles.map(file => ({
            ...file,
            id: file.docMid + serialNo,
            serialNo: serialNo++
          }));
          allDocFiles.push(...docFilesWithIds);
        }
      });

      setTableData(allDocFiles);

    } catch (error) {
      console.error("Error fetching documents:", error);
      toast.error("Failed to fetch documents.");
    } finally {
      setIsLoadingFiles(false);
    }
  }, [
    selectedFileType,
    selectedSynopsis,
    selectedDepartment,
    selectedSubDepartment,
    selectedFileNo,
    isDevIdPresent,
    devIdNum,
    areBothSecureIdsPresent,
    subDeptIDNum,
  ]);

  const fetchDepartments = useCallback(async () => {
    setLoadingDepartments(true);
    const collectData = {
      id: isDevIdPresent ? devIdNum : -1,
      nodeID: -1,
      titleID: -1,
    };

    try {
      const response = await axios.post<{ data: Department[] }>(
        HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`,
        collectData
      );

      const departments = response.data.data || [];
      const departmentOptions = departments.map((dept: Department) => ({
        label: dept.name,
        value: dept.id
      }));

      setDepartmentOptions(departmentOptions);

      // If devId is present, set the department immediately
      if (isDevIdPresent) {
        const foundDept = departmentOptions.find(dept => dept.value === devIdNum);
        if (foundDept) {
          setSelectedDepartment(foundDept);
          // Fetch sub-departments for this department
          await fetchSubDepartments(devIdNum, true);
        }
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
      toast.error("Failed to fetch departments.");
    } finally {
      setLoadingDepartments(false);
    }
  }, [isDevIdPresent, devIdNum]);

  const fetchSubDepartments = useCallback(async (deptId: number, isInitialSetup: boolean = false) => {
    if (deptId === -1) {
      setSubDepartmentOptions([]);
      return;
    }

    setLoadingSubDepartments(true);
    try {
      const response = await axios.post<{ data: SubDepartment[] }>(
        HOST_URL.HOST_URL2 + `SubDepartmentMaster/GetSubDepartmentMaster`,
        {
          subDeptID: -1,
          deptID: deptId
        }
      );

      const subDepartments = response.data.data || [];
      const subDepartmentOptions = subDepartments.map((subDept: SubDepartment) => ({
        label: subDept.subDeptName,
        value: subDept.subDeptID
      }));

      setSubDepartmentOptions(subDepartmentOptions);

      // If this is initial setup and both secure IDs are present, find and set the sub-department
      if (isInitialSetup && areBothSecureIdsPresent && subDeptIDNum !== -1) {
        const foundSubDept = subDepartmentOptions.find(subDept => subDept.value === subDeptIDNum);
        if (foundSubDept) {
          setSelectedSubDepartment(foundSubDept);
        }
      }
    } catch (error) {
      console.error("Error fetching sub-departments:", error);
      toast.error("Failed to fetch sub-departments.");
      setSubDepartmentOptions([]);
    } finally {
      setLoadingSubDepartments(false);
    }
  }, [areBothSecureIdsPresent, subDeptIDNum]);

  const fetchFileTypes = useCallback(async (deptId = -1) => {
    setLoadingFileTypes(true);
    const collectData = {
      docID: -1,
      parentDocId: deptId,
      userId: ""
    };

    try {
      const response = await axios.post<{ data: FileType[] }>(
        HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`,
        collectData
      );

      const fileTypes = response.data.data || [];
      const fileTypeOptions = fileTypes.map((fileType: FileType) => ({
        label: fileType.doc_Name,
        value: fileType.docID
      }));

      setFileTypeOptions(fileTypeOptions);
    } catch (error) {
      console.error("Error fetching file types:", error);
      toast.error("Failed to fetch file types.");
    } finally {
      setLoadingFileTypes(false);
    }
  }, []);

  const generateAutoCompleteOptions = useCallback((documents: DocumentData[]) => {
    // Synopsis Options
    const synopses = Array.from(new Set(documents
      .map(doc => doc.synopsis)
      .filter(Boolean)))
      .map(synopsis => ({
        label: synopsis as string,
        value: synopsis as string
      }));
    setSynopsisOptions(synopses);

    // File No Options
    const fileNos = Array.from(new Set(documents
      .map(doc => doc.fileNo)
      .filter(Boolean)))
      .map(fileNo => ({
        label: fileNo as string,
        value: fileNo as string
      }));
    setFileNoOptions(fileNos);
  }, []);

  // Fetch documents when any filter changes
  useEffect(() => {
    if (!initialDataFetched.current) return;

    const timer = setTimeout(() => {
      fetchDocumentsWithFilters();
    }, 500);

    return () => clearTimeout(timer);
  }, [
    selectedFileType?.value,
    selectedSynopsis?.value,
    selectedSubDepartment?.value,
    selectedFileNo?.value,
    initialDataFetched.current,
    selectedDepartment?.value
  ]);

  // Handle individual filter changes
  const handleFileTypeChange = useCallback((event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
    setSelectedFileType(newValue);
  }, []);

  const handleSynopsisChange = useCallback((event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
    setSelectedSynopsis(newValue);
  }, []);

  const handleDepartmentChange = useCallback((event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
    // Only allow department change if devId is not present
    if (!isDevIdPresent) {
      setSelectedDepartment(newValue);
    }
  }, [isDevIdPresent]);

  const handleSubDepartmentChange = useCallback((event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
    // Only allow sub-department change if both secure IDs are not present
    // If only devId is present, user can change sub-department
    if (!areBothSecureIdsPresent) {
      setSelectedSubDepartment(newValue);
    }
  }, [areBothSecureIdsPresent]);

  const handleFileNoChange = useCallback((event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
    setSelectedFileNo(newValue);
  }, []);

  // Reset all filters
  const handleResetFilters = useCallback(() => {
    setSelectedFileType(null);
    setSelectedSynopsis(null);

    // Only reset department and sub-department if secure IDs are not present
    if (!isDevIdPresent) {
      setSelectedDepartment(null);
      setSelectedSubDepartment(null);
      setSubDepartmentOptions([]);
    } else if (isDevIdOnlyPresent) {
      // If only devId is present, keep department selected but reset sub-department
      setSelectedSubDepartment(null);
    }

    setSelectedFileNo(null);
    setPDFShow(null);
  }, [isDevIdPresent, isDevIdOnlyPresent]);

  // Fetch Specific PDF Data by ID
  const fetchPdfData = useCallback(async (docMid: number) => {
    setIsLoadingPdf(true);
    setPDFShow(null);
    const collectData = {
      docMid: docMid,
      fileTypId: 0,
      divisionid: 0,
      subDeptID: 0,
      subsubjId: 0,
      user_Id: 0,
      fileNo: "",
      synopsis: "",
      complt: ""
    };
    try {
      const response = await axios.post<{ data: any[] }>(
        HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`,
        collectData
      );

      if (
        response?.data?.data &&
        response.data.data.length > 0 &&
        response.data.data[0]?.member_DocFiles &&
        response.data.data[0].member_DocFiles.length > 0 &&
        response.data.data[0].member_DocFiles[0]?.pdfPath
      ) {
        setPDFShow(response.data.data[0].member_DocFiles[0].pdfPath);
      } else {
        console.warn("PDF data not found in response for docMid:", docMid);
        toast.info("PDF data not found for this document.");
        setPDFShow(null);
      }
    } catch (error) {
      console.error("Error fetching PDF data:", error);
      toast.error("Failed to fetch PDF data.");
      setPDFShow(null);
    } finally {
      setIsLoadingPdf(false);
    }
  }, []);

  // Open Dialog Handler (for Eye icon)
  const handleOpenDialog = useCallback((rowData: DocFile) => {
    setSelectedRowData(rowData);
    setOpenDialog(true);
    fetchPdfData(rowData.docMid);
  }, [fetchPdfData]);

  // Handle Info icon click - Open PDF URL in new tab
  const handleInfoClick = useCallback((pdfPath: string) => {
    if (pdfPath) {
      window.open(pdfPath, '_blank', 'noopener,noreferrer');
    } else {
      toast.error("No PDF URL available");
    }
  }, []);

  // Close Dialog Handler
  const handleCloseDialog = useCallback(() => {
    setOpenDialog(false);
    setTimeout(() => {
      setSelectedRowData(null);
      setPDFShow(null);
      setIsLoadingPdf(false);
    }, 300);
  }, []);

  const toggleFilters = useCallback(() => {
    setFiltersExpanded(!filtersExpanded);
  }, [filtersExpanded]);

  // Function to get appropriate placeholder text for sub-department
  const getSubDepartmentPlaceholder = useCallback(() => {
    if (areBothSecureIdsPresent) {
      return "Pre-selected from secure ID";
    } else if (isDevIdOnlyPresent) {
      return "Select sub-department (optional)";
    } else if (selectedDepartment) {
      return "Select sub-department";
    } else {
      return "Select department first";
    }
  }, [areBothSecureIdsPresent, isDevIdOnlyPresent, selectedDepartment]);

  return (
    <>
      <CssBaseline />
      <ToastApp />
      <Container maxWidth="lg" sx={{ mt: 1, mb: 1 }}>
        <Paper elevation={3} sx={{ p: 1, borderRadius: 2 }}>
          {/* Header Section */}
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <Typography variant="h5" component="h2" sx={{ ml: 1, fontWeight: 'medium' }}>
              Document Viewer
            </Typography>
          </Box>
          {/* Enhanced Compact Filters Section */}
          <Card
            variant="outlined"
            sx={{
              mb: 2,
              '& .MuiCardContent-root': {
                padding: 1,
                '&:last-child': {
                  paddingBottom: 1
                }
              }
            }}
          >
            <CardContent>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  cursor: 'pointer',
                  p: 0.5
                }}
                onClick={toggleFilters}
              >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <FilterListIcon sx={{ mr: 1, fontSize: 18 }} />
                  <Typography variant="h6" sx={{ fontSize: 18 }}>
                    Filters
                  </Typography>
                </Box>
                {/* Reset Button */}
                <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center' }}>
                  <Button
                    variant="outlined"
                    onClick={handleResetFilters}
                    size="small"
                    sx={{ minWidth: 'auto', px: 1 }}
                  >
                    Reset
                  </Button>
                </Box>
                <IconButton size="small">
                  {filtersExpanded ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              </Box>

              <Collapse in={filtersExpanded}>
                <Grid container spacing={1}>
                  {/* Department Autocomplete */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                      options={departmentOptions}
                      value={selectedDepartment}
                      onChange={handleDepartmentChange}
                      getOptionLabel={(option) => option.label}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                      loading={loadingDepartments}
                      disabled={isDevIdPresent}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Department"
                          variant="outlined"
                          size="small"
                          fullWidth
                          placeholder={isDevIdPresent ? "Pre-selected from secure ID" : "Select department"}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loadingDepartments ? <CircularProgress color="inherit" size={18} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                  </Grid>

                  {/* Sub-Department Autocomplete */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                      options={subDepartmentOptions}
                      value={selectedSubDepartment}
                      onChange={handleSubDepartmentChange}
                      getOptionLabel={(option) => option.label}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                      loading={loadingSubDepartments}
                      disabled={!selectedDepartment || areBothSecureIdsPresent || loadingSubDepartments}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Sub-Department"
                          variant="outlined"
                          size="small"
                          fullWidth
                          placeholder={getSubDepartmentPlaceholder()}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loadingSubDepartments ? <CircularProgress color="inherit" size={18} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                  </Grid>

                  {/* Synopsis Autocomplete */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                      options={synopsisOptions}
                      value={selectedSynopsis}
                      onChange={handleSynopsisChange}
                      getOptionLabel={(option) => option.label}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="File name"
                          variant="outlined"
                          size="small"
                          fullWidth
                          placeholder="Select file name"
                        />
                      )}
                    />
                  </Grid>

                  {/* File Type Autocomplete */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                      options={fileTypeOptions}
                      value={selectedFileType}
                      onChange={handleFileTypeChange}
                      getOptionLabel={(option) => option.label}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                      loading={loadingFileTypes}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="File Type"
                          variant="outlined"
                          size="small"
                          fullWidth
                          placeholder="Select file type"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loadingFileTypes ? <CircularProgress color="inherit" size={18} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                  </Grid>

                  {/* File No Autocomplete */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                      options={fileNoOptions}
                      value={selectedFileNo}
                      onChange={handleFileNoChange}
                      getOptionLabel={(option) => option.label}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="File No"
                          variant="outlined"
                          size="small"
                          fullWidth
                          placeholder="Select file number"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Collapse>
            </CardContent>
          </Card>

          {/* DataGrid Section */}
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Paper
                variant="outlined"
                sx={{
                  width: '100%',
                  overflow: 'hidden',
                  "& .MuiDataGrid-colCell": {
                    backgroundColor: `var(--grid-headerBackground)`,
                    color: `var(--grid-headerColor)`,
                    fontSize: 14,
                    fontWeight: 600
                  },
                }}
              >
                {tableData.length > 0 ? (
                  <Box sx={{ width: '100%', backgroundColor: `var(--grid-background)` }}>
                    <DataGrid
                      rows={tableData}
                      columns={columns}
                      autoHeight
                      slots={{
                        toolbar: GridToolbar,
                      }}
                      rowSpacingType="border"
                      pagination={true}
                      pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                        value: size,
                        label: `${size}`,
                      }))}
                      initialState={{
                        pagination: { paginationModel: { pageSize: 5 } },
                      }}
                      slotProps={{
                        toolbar: {
                          showQuickFilter: true,
                        },
                      }}
                      loading={isLoadingFiles}
                      sx={{
                        '& .MuiDataGrid-cell': {
                          borderBottom: '1px solid #e0e0e0',
                          fontSize: '0.875rem',
                        },
                        '& .MuiDataGrid-row:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                        '& .MuiDataGrid-toolbarContainer': {
                          padding: 1,
                        },
                      }}
                    />
                  </Box>
                ) : (
                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    p: 2,
                    color: 'text.secondary',
                    minHeight: 120
                  }}>
                    <FindInPageIcon sx={{ mr: 1, fontSize: 30 }} />
                    <Typography variant="body1">
                      {isLoadingFiles ? "Loading documents..." : "No documents found for the selected filters"}
                    </Typography>
                  </Box>
                )}
              </Paper>
            </Grid>
          </Grid>
        </Paper>

        {/* PDF Viewer Dialog (3D Flipbook) */}
        <Dialog
          fullScreen
          open={openDialog}
          onClose={handleCloseDialog}
          TransitionComponent={Transition}
          aria-labelledby="pdf-viewer-dialog-title"
        >
          <DialogTitle sx={{ m: 0, p: 2, backgroundColor: 'primary.main', color: 'white' }} id="pdf-viewer-dialog-title">
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h6" component="div">
                PDF Viewer - {selectedRowData?.pdfName || 'Document'}
              </Typography>
              <IconButton
                aria-label="close"
                onClick={handleCloseDialog}
                sx={{ color: 'white' }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent dividers sx={{
            p: 0,
            backgroundColor: '#f7f7f7',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden'
          }}>
            {isLoadingPdf ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <CircularProgress size={60} />
                <Typography sx={{ mt: 2 }}>Loading PDF...</Typography>
              </Box>
            ) : pdfShow ? (
              <Box sx={{ width: '100%', height: '100%', overflow: 'auto' }}>
                <Flipbook filePath={pdfShow} />
              </Box>
            ) : (
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', textAlign: 'center', p: 3 }}>
                <NoSimIcon sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
                <Typography variant="h6" color="text.secondary">
                  No Pdf Preview Available
                </Typography>
              </Box>
            )}
          </DialogContent>
        </Dialog>
      </Container>
    </>
  );
};

export default DocViewer;